import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import columns from './columns'
import { Exhibition } from 'hlj-components'

@inject('detailStore')
@observer
export default class extends Component {
  render() {
    const { orderDetail } = this.props.detailStore
    return (
      <div style={{ flex: 1 }}>
        <Exhibition columns={columns} data={orderDetail} />
      </div>
    )
  }
}
